import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import type { User, MenuItem } from '@/types'

interface UserState {
  user: User | null
  token: string | null
  permissions: string[]
  isLoggedIn: boolean
  collapsed: boolean
  theme: 'light' | 'dark'
  loading: boolean
  menus: MenuItem[]
  breadcrumbs: Array<{ title: string; path: string }>
}

const initialState: UserState = {
  user: null,
  token: null, // 由 Redux Persist 处理
  permissions: [],
  isLoggedIn: false,
  collapsed: false,
  theme: 'light', // 由 Redux Persist 处理
  loading: false,
  menus: [],
  breadcrumbs: [],
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User | null>) => {
      state.user = action.payload
      state.isLoggedIn = !!action.payload
    },
    setToken: (state, action: PayloadAction<string | null>) => {
      state.token = action.payload
      // Redux Persist 会自动处理持久化，不需要手动操作 localStorage
    },
    setPermissions: (state, action: PayloadAction<string[]>) => {
      state.permissions = action.payload
    },
    logout: (state) => {
      state.user = null
      state.token = null
      state.permissions = []
      state.isLoggedIn = false
      state.menus = []
      state.breadcrumbs = []
      // Redux Persist 会自动处理持久化清理
    },
    updateUserInfo: (state, action: PayloadAction<Partial<User>>) => {
      if (state.user) {
        state.user = { ...state.user, ...action.payload }
      }
    },
    setCollapsed: (state, action: PayloadAction<boolean>) => {
      state.collapsed = action.payload
    },
    toggleCollapsed: (state) => {
      state.collapsed = !state.collapsed
    },
    setTheme: (state, action: PayloadAction<'light' | 'dark'>) => {
      state.theme = action.payload
      // Redux Persist 会自动处理持久化
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setMenus: (state, action: PayloadAction<MenuItem[]>) => {
      state.menus = action.payload
    },
    setBreadcrumbs: (state, action: PayloadAction<Array<{ title: string; path: string }>>) => {
      state.breadcrumbs = action.payload
    },
  },
})

export const { 
  setUser, 
  setToken, 
  setPermissions, 
  logout, 
  updateUserInfo,
  setCollapsed,
  toggleCollapsed,
  setTheme,
  setLoading,
  setMenus,
  setBreadcrumbs
} = userSlice.actions
export default userSlice.reducer
